import Vue from 'vue'

let BOOK_PlAYER_INFO_CACHE = 'BOOK_PlAYER_INFO_CACHE'

function getAllPlayerCache() {
  try {
    return JSON.parse(window.localStorage.getItem(BOOK_PlAYER_INFO_CACHE)) || []
  } catch (e) {
    return []
  }
}

function getPlayerCache(bus) {
  if (!bus.userInfo.userKey) {
    setTimeout(() => {
      getPlayerCache(bus)
    }, 1000)
    return
  }
  let allCache = getAllPlayerCache()
  let cacheInfo = allCache.find(
    item => item.userKey + '' === bus.userInfo.userKey + ''
  )
  if (cacheInfo) {
    bus.polyvConfig = cacheInfo.config
    bus.audioInfo = cacheInfo.audioInfo
    // bus.loadPlayerBar = true
  } else {
    // bus.loadPlayerBar = false
  }
}

function setAllPlayerCache(userKey, audioInfo, config) {
  try {
    let cache = getAllPlayerCache()
    let hased = false
    cache = cache.map(v => {
      if (userKey + '' === v.userKey + '') {
        hased = true
        return {
          ...v,
          audioInfo: audioInfo,
          config: config
        }
      } else {
        return v
      }
    })

    if (!hased) {
      cache.push({
        userKey: userKey + '',
        audioInfo: audioInfo,
        config: config
      })
    }
    window.localStorage.setItem(BOOK_PlAYER_INFO_CACHE, JSON.stringify(cache))
    return true
  } catch (e) {
    console.log('set storage player info, fail', e)
    return false
  }
}

function removePlayerCache(bus) {
  let allCache = getAllPlayerCache()
  let cacheInfo = allCache.find(
    item => item.userKey + '' === bus.$data.userInfo.userKey + ''
  )
  allCache.splice(allCache.indexOf(cacheInfo), 1)
  if (allCache.length) {
    window.localStorage.setItem(
      BOOK_PlAYER_INFO_CACHE,
      JSON.stringify(allCache)
    )
  } else {
    window.localStorage.removeItem(BOOK_PlAYER_INFO_CACHE)
  }
}

const createBus = () => {
  const bus = new Vue({
    data: {
      // 用户信息
      userInfo: {},
      // 用户其他信息(isVip，vipId)
      userOtherInfo: {},
      // 渠道信息
      channelConfig: {},
      // 默认值，壹心理公开课的渠道id
      channelId: '',
      // 课程或者读书会标志
      sourceName: '',
      //
      disCode: '',
      //loading设置
      LOADING_CONFIG: {
        show: false,
        text: ''
      },
      //Toast 设置
      TOAST_CONFIG: {
        show: false,
        icon: '',
        text: ''
      },
      // 搜索页数据
      SEARCHED: {
        word: '',
        result: []
      },
      // 分类页分类
      SORT_TAGS: [],
      DIRECTION: 'forward',
      BOOKPARTY_USERINFO: null,
      //播放器相关
      loadPlayerBar: true, //是否加载播放条
      showPlayerBar: true, //是否显示播放条
      audioPlayer: null,
      audioInfo: null, //音频信息：封面，标题，duration，书本id，userKey等
      audioNowTime: 0, //播放进度
      audioLearnTime: 0, //学习时长
      isPlaying: false, //是否在播放中
      learnTimer: null,
      polyvConfig: null,
      isBgPlaying: false,
      bgMusicPlayer: null,
      historyCount: 0,
      toIndex: '',
      fromIndex: '',
      token: '',
      completeCount: 0,
      isPlayComplete: false,
      countTime: 0,
      stepIndex: 0,
      bgMusicPlayIng: false,
      meditatingId: '',
      learningTime: 0,
      seekArray: [], // 会进快退的记录
      showEndMediComfirm: false
    }
  })
  bus.$on('LEARNING_TIME_CLOCK', () => {
    bus.learningTime++
  })
  bus.$on('SET_LEARNING_TIME', learningTime => {
    bus.learningTime = learningTime
  })
  bus.$on('SET_BG_MUSIC_PLAY', flag => {
    bus.bgMusicPlayIng = flag
  })
  bus.$on('SET_MEDITATING_ID', meditatingId => {
    bus.meditatingId = meditatingId
  })

  bus.$on('SET_COUNT_TIME', time => {
    bus.countTime = time
  })
  bus.$on('SET_STEP_INDEX', index => {
    bus.stepIndex = index
  })
  bus.$on('SET_IS_PLAY_COMPLETE', flag => {
    bus.isPlayComplete = flag
  })
  bus.$on('SET_HISTORY_COUNT', count => {
    bus.historyCount = count
  })
  bus.$on('SET_COMPLETE_COUNT', count => {
    bus.completeCount = count
  })
  bus.$on('SET_TOKEN', token => {
    bus.token = token
  })
  bus.$on('SET_TO_INDEX', toIndex => {
    bus.toIndex = toIndex
  })
  bus.$on('SET_FROM_INDEX', fromIndex => {
    bus.fromIndex = fromIndex
  })

  bus.$on('SET_BOOKPARTY_USERINFO', info => {
    bus.BOOKPARTY_USERINFO = info
  })
  //用户信息
  bus.$on('SET_USER_INFO', info => {
    info.nickname = decodeURI(
      encodeURI(info.nickname).replace(new RegExp('%00', 'g'), '')
    )
    //app下拉属性，会把bus信息刷掉
    localStorage.setItem('info', JSON.stringify(info))
    bus.userInfo = info
  })
  // 用户其他信息(isVip，vipId)
  bus.$on('SET_OTHER_USER_INFO', msg => {
    bus.userOtherInfo = msg
  })
  // 赋值渠道信息
  bus.$on('SET_CHANNEL_CONFIG', channelConfig => {
    bus.channelConfig = channelConfig
  })
  // 赋值渠道id
  bus.$on('SET_CHANNEL_ID', channelId => {
    bus.channelId = channelId
  })
  // 课程或者读书会标志
  bus.$on('SET_SOURCE_NAME', sourceName => {
    bus.sourceName = sourceName
  })
  bus.$on('SET_DIS_CODE', disCode => {
    bus.disCode = disCode
  })

  //设置loading
  bus.$on('SET_LOADING', ({ show, text }) => {
    const LOADING_CONFIG = bus.LOADING_CONFIG
    LOADING_CONFIG.show = show ? show : !LOADING_CONFIG.show
    text ? (LOADING_CONFIG.text = text) : ''
  })
  //设置toast
  bus.$on('SET_TOAST', ({ show, icon, text }) => {
    const TOAST_CONFIG = bus.TOAST_CONFIG
    TOAST_CONFIG.show = show ? show : !TOAST_CONFIG.show
    icon ? (TOAST_CONFIG.icon = icon) : ''
    text ? (TOAST_CONFIG.text = text) : ''
  })
  //设置音频信息
  bus.$on('SET_AUDIO_INFO', info => {
    bus.audioInfo = info
  })
  //设置当天播放时长
  bus.$on('SET_AUDIO_LEARNTIME', time => {
    bus.audioLearnTime = time
  })
  // 缓存polyvConfig和audioInfo到本地
  bus.$on('SET_LOCAL_AUDIO_CONFIG', config => {
    bus.polyvConfig = config
    setAllPlayerCache(bus.audioInfo.userKey, bus.audioInfo, bus.polyvConfig)
  })
  //获取播放缓存
  bus.$on('GET_LOCAL_AUDIO_CONFIG', () => {
    getPlayerCache(bus)
  })
  // 清除配置config
  bus.$on('CLEAR_LOCAL_AUDIO_CONFIG', () => {
    removePlayerCache(bus)
  })
  //是否正在播放
  bus.$on('SET_IS_PLAYING', isPlaying => {
    bus.isPlaying = isPlaying
  })
  //背景音乐是否正在播放
  bus.$on('SET_BG_IS_PLAYING', isPlaying => {
    bus.isBgPlaying = isPlaying
  })
  // 设置背景音乐播放器对象
  bus.$on('SET_BG_PlAYER_OBJECT', player => {
    bus.bgMusicPlayer = player
  })
  //播放进度
  bus.$on('SET_AUDIO_NOWTIME', time => {
    bus.audioNowTime = time
  })
  // 设置播放器对象
  bus.$on('SET_PlAYER_OBJECT', player => {
    bus.audioPlayer = player
    console.log('bus.audioPlayer', bus.audioPlayer)
  })
  bus.$on('GET_LOCAL_AUDIO_LEARNTIME', () => {
    let today = new Date()
    let dateStr =
      String(today.getFullYear()) +
      String(today.getMonth()) +
      String(today.getDate())
    let learnTime = 0,
      cacheLearnTime = window.localStorage.getItem('LOCAL_AUDIO_LEARNTIME')
    if (cacheLearnTime) {
      let cacheDate = cacheLearnTime.split('date')[1]
      if (dateStr == cacheDate) {
        learnTime = cacheLearnTime.split('date')[0]
      }
    }
    bus.audioLearnTime = learnTime
  })
  // 加载播放条
  bus.$on('LOAD_PlAYER_BAR', () => {
    bus.loadPlayerBar = true
  })
  bus.$on('SET_SEARCHED_WORD', str => {
    bus.SEARCHED.word = str
  })
  bus.$on('SET_SEARCHED_RESULT', result => {
    bus.SEARCHED.result = result
  })
  bus.$on('UPDATE_DIRECTION', direction => {
    bus.DIRECTION = direction
  })
  bus.$on('SET_SORT_TAGS', tags => {
    bus.SORT_TAGS = tags
  })
  // 销毁播放条
  bus.$on('DESTROY_PlAYER_BAR', () => {
    bus.loadPlayerBar = false
  })

  // 显示播放条
  bus.$on('SHOW_PlAYER_BAR', () => {
    bus.showPlayerBar = true
  })
  // 隐藏播放条
  bus.$on('HIDE_PlAYER_BAR', () => {
    bus.showPlayerBar = false
  })
  // 缓存learnTime到本地
  bus.$on('SET_LOCAL_AUDIO_LEARNTIME', () => {
    let today = new Date()
    let dateStr =
      String(today.getFullYear()) +
      String(today.getMonth()) +
      String(today.getDate())
    window.localStorage.setItem(
      'LOCAL_AUDIO_LEARNTIME',
      bus.audioLearnTime + 'date' + dateStr
    )
  })
  bus.$on('ADD_AUDIO_LEARNTIME', () => {
    bus.audioLearnTime++
  })

  bus.$on('SET_SEEK_ARRAY', time => {
    bus.seekArray = time
  })
  bus.$on('SET_END_MEDI_COMFIRM', booleanData => {
    bus.showEndMediComfirm = !!booleanData
  })

  return bus
}

export default createBus
